<template>
    <div class="col-12">
        <div class="form-group row m-b-sm">
            <div class="col p-r-5">
                <button v-if="!disabled" class="btn btn-primary m-t-xs" type="button" @click="$emit('addNewItem')">
                    <i class="fa fa-plus"></i> {{ __('add_another_listing') }}
                </button>
            </div>

            <div class="col text-right max-w-160 p-l-5 p-r-5"></div>
            <div class="col text-right max-w-160 p-l-5 p-r-5"></div>
            <div class="col text-right max-w-200 p-l-5 p-r-5"></div>

            <div :class="{'has-error': hasError('gross_amount') }" class="col text-right max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :errors="getErrors('gross_amount')"
                    :label="__('sum')"
                    :value="sums.gross | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div :class="{'has-error': hasError('margin') }" class="max-w-120 col text-right  p-l-5 p-r-5">
                <InputWrapper
                    :errors="getErrors('margin')"
                    :label="__('sum')"
                    :value="sums.margin | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div class="max-w-130 col  p-l-5 p-r-5"></div>

            <div :class="{'has-error': hasError('margin_vat') }" class="max-w-120 col text-right  p-l-5 p-r-5">
                <InputWrapper
                    :errors="getErrors('margin_vat')"
                    :label="__('sum')"
                    :value="sums.margin_vat | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div style="width: 45px"></div>
        </div>
    </div>
</template>

<script>
import hasErrors from "../../../../mixins/hasErrors";
import InputWrapper from "../../../form/InputWrapper";

export default {
    name: "MarginSummaryRow",
    components: {InputWrapper},
    mixins: [hasErrors],
    props: {
        sums: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

};
</script>

